import { Injectable } from '@angular/core';
import { getCurrentBreakpoint } from '@shared/ui/breakpoints';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  hovered: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() { }

  get isMobile() {
    const mobile = this.getCurrentBreakpoint() === 'xs';
    return mobile;
  }

  getCurrentBreakpoint = () => getCurrentBreakpoint();

  get modalSheetOptions() {
    const options = {
      breakpoint: this.isMobile ? [0, 1] : undefined,
      initialBreakpoint: this.isMobile ? 1 : undefined,
      handle: false,
      cssClass: this.isMobile ? ['bottom-sheet', 'height-auto'] : 'auto-height'
    };
    return options;
  }
}
